import { jsx as _jsx } from "react/jsx-runtime";
export var KCOLSEPARATOR_SIZE;
(function (KCOLSEPARATOR_SIZE) {
    KCOLSEPARATOR_SIZE["sm"] = "sm";
    KCOLSEPARATOR_SIZE["md"] = "md";
    KCOLSEPARATOR_SIZE["lg"] = "lg";
    KCOLSEPARATOR_SIZE["xl"] = "xl";
})(KCOLSEPARATOR_SIZE || (KCOLSEPARATOR_SIZE = {}));
const SizeTransform = {
    [KCOLSEPARATOR_SIZE.sm]: "xs",
    [KCOLSEPARATOR_SIZE.md]: "sm",
    [KCOLSEPARATOR_SIZE.lg]: "md",
    [KCOLSEPARATOR_SIZE.xl]: "lg",
};
export const KColSeparator = ({ minShowSize, forceHorizontal = false }) => {
    return _jsx("span", { className: `colSeparator ${minShowSize ? SizeTransform[minShowSize] : ""} ${forceHorizontal ? "force-horizontal" : ""}` });
};
